import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {getTableStyle} from "../utils/GridAllocationUtil";
import Text from "@amzn/meridian/text";

/**
 * Renders the aisle info section in the grid allocation view
 */
class SortLocationInfo extends Component {
    render() {
        const {sortLocationInfo} = this.props;
        return (
            <tr style={getTableStyle("none")}>
                <td key={"1"} style={getTableStyle("none")}>
                    <Text>{sortLocationInfo.label}</Text>
                </td>
                <td key={"2"} style={getTableStyle(sortLocationInfo.color)}>
                    <Text>{sortLocationInfo.reservedFor}</Text>
                </td>
            </tr>
        )
    }
}

const mapStateToProps = state => ({
});
export default withRouter(connect(mapStateToProps)(SortLocationInfo));


// WEBPACK FOOTER //
// ./src/components/gridAllocation/SortLocationInfo.js